import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const contactDataClassName = DataClassName.CONTACT
const contactEndpoint = PisaDataClassEndpoint.CONTACT

export function pisaContactDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(contactDataClassName, {
    title: contactDataClassName,
    restApi: createPisaRestApiConfig(contactEndpoint),
    attributes,
  })
}
